import Dad from './Dad.webp'
import Laundry from './Laundry.webp';
import Lilies from './Lilies.webp';
import Places from './Places.webp'

export default {
    Dad,
    Laundry,
    Lilies,
    Places
}